export default __webpack_public_path__ + "static/media/CG.58468520.svg";